// extracted by mini-css-extract-plugin
export default {"projectTags":"Tags_projectTags__9Wyuy","tag":"Tags_tag__b+mGj"};